/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useEffect } from 'react';
import { usePlayFlag } from './../../components/topicScroll';

import './animation028.less';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation028Item {
  text: string;
}

interface IAnimation028Props {
  items: IAnimation028Item[];
  className?: string;
  onCompleted?: () => void;
}

const Animation028: React.FunctionComponent<IAnimation028Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      onCompleted && onCompleted();
    }
  };

  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };

  return (
    <div ref={crrRef} className={`animation028 component ${className || ''}`}>
      {items.map((itm: IAnimation028Item, idx: number) => (
        <div key={idx} className="animation028-contaner">
          <div
            onClick={() => clickToPlay()}
            className={`animation028-item r${idx + 1} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <img
              className="click-point"
              onClick={() => clickToPlay()}
              style={{
                display: play <= 1 ? 'block' : 'none',
              }}
              src={ImgPoint}
              alt=""
            />
            <img
              className="animation028-bgImg"
              src={require(`../../../../../assets/a028-${idx + 1}.png`).default}
              alt=""
            />
            <div
              className="text"
              dangerouslySetInnerHTML={{ __html: itm.text }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Animation028;
